<template>
  <va-card :title="$t('menu.palletized_products')">
    <va-data-table
      :fields="fields"
      :data="data"
      :loading="loading"
      no-pagination
    >
    <!-- <template slot="actions" slot-scope="props">
      <va-button
        small
        outline
        color="success"
        icon="fa fa-edit"
        class="ma-0"
        :to="{ name: 'form-load-products', params: { loadId: props.rowData.id } }" 
      >
        {{ $t('menu.products') }}
      </va-button>
      <va-button
        small
        outline
        color="green"
        icon="fa fa-edit"
        class="ma-0"
        :to="{ name: 'form-loads', params: { id: props.rowData.id } }" 
      >
        {{ $t('menu.edit') }}
      </va-button>
      <va-button 
        small 
        outline 
        color="danger" 
        icon="fa fa-remove"
        class="ma-0"
        @click="remove(props.rowData.id)" 
      >
        {{ $t('tables.delete') }}
      </va-button>
    </template> -->
    </va-data-table>
  </va-card>
</template>

<script>

import PalletizedProductsAPI from '@/services/PalletizedProductsAPI'
import moment from 'moment'

export default {
  name: 'modals',
  data () {
    return {
      data: [],
      loading: true,
      datepicker: {
        today: moment(new Date()).format('DD-MM-YYYY')
      },
      showModal: false,
      loadID: '',
      bayID: ''
    }
  },
  mounted () {
    var self = this
    self.loadID = this.$route.params.loadID
    self.bayID = this.$route.params.bayID
    PalletizedProductsAPI.getAllPalletizedProductsByBayID(self.loadID, self.bayID).then(response => {
      self.data = response.data
      self.loading = false
    })
  },
  // updated () {
  //   var self = this
  //   PalletizedProductsAPI.getAllPalletizedProductsByBayID(self.loadID, self.bayID).then(response => {
  //     self.data = response.data
  //     self.loading = false
  //   })
  // },
  computed: {
    fields () {

      return [{
        name: 'product_label',
        title: this.$t('tables.palletized_products.product_label'),
      },
      {
        name: 'layer',
        title: this.$t('tables.palletized_products.layer'),
      },
      {
        name: 'quantity',
        title: this.$t('tables.palletized_products.quantity'),
      },
      {
        name: 'fill_percentage',
        title: this.$t('tables.palletized_products.fill_percentage')
      },
      {
        name: "pallet_heigth",
        title: this.$t('tables.palletized_products.pallet_height')
      },
      {
        name: 'delivery_sequence',
        title: this.$t('tables.palletized_products.delivery_sequence'),
      },
      {
        name: 'client_name',
        title: this.$t('tables.palletized_products.client_name'),
      },
      {
        name: 'package_name',
        title: this.$t('tables.palletized_products.package_name'),
        width: '20%',
      },
      {
        name: "ballast",
        title: this.$t('tables.palletized_products.ballast'),
      },
      {
        name: "height",
        title: this.$t('tables.palletized_products.height'),
      },
      {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    }
  },
  filters: {
    moment: function (delivery_date) {
      return moment(delivery_date).format('YYYY-MM-DD');
    }
  },
  methods: {
    moment: function () {
      return moment();
    },
    updateShowModal(boolean) {
      this.showModal = boolean
    },
    getMessage () {
      return "Informações da Carga..."
    }
  },
}
</script>

<style lang="scss">
</style>
